export default __webpack_public_path__ + "static/reactui-d67381e3fefb19cb8f6ec769f7efda1b.svg";